import { useEffect, useState } from "react";
import { CheckboxMultipleSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";
import { BadgeCheck, CircleCheck, CirclePlus, Trash } from "lucide-react";

type AppCustomPropertySettingsCheckboxMultipleProps = {
    settings: CheckboxMultipleSettings
    onChange: (settings: CheckboxMultipleSettings) => void;
}

export const AppCustomPropertySettingsCheckboxMultiple = ({settings, onChange} : AppCustomPropertySettingsCheckboxMultipleProps) => {

    const [choices, setChoices] = useState<string[]>([]);
    const [defaultChoices, setDefaultChoices] = useState<string[]>([]);

    const [flashEmpty, setFlashEmpty] = useState(false);

    useEffect(() => {
        const newSettings = {...settings, default: defaultChoices, choices};
        onChange(newSettings);
    }, [choices, defaultChoices]);

    useEffect(() => {
        if (flashEmpty) {
            setTimeout(() => {
                setFlashEmpty(false);
            }, 1000);
        }
    }, [flashEmpty]);

    return (
        <div className="app-custom-property-settings-container">

            <div className="app-custom-property-group">
                <div className="app-custom-property-label">
                    Alphabetize
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.alphabetize}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                alphabetize: checked
                            });
                        }}
                    />
                </div>
            </div>

            <div className="app-custom-property-group">
                <div className="app-custom-property-label">
                    Allow None
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.allowNone}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                allowNone: checked
                            });
                        }}
                    />
                </div>
            </div>

            Checkbox Choices: 
            <br />
            <span
                style={{cursor: "pointer", color: "blue"}}
                onClick={() => {
                    if (choices.includes("")) {
                        setFlashEmpty(true);
                        return;
                    } 

                    setFlashEmpty(false);
                    setChoices([...choices, ""]);
                }}
            >
                Add Choice
            </span>

            <div className="app-custom-property-choices">
                {choices.map((choice, index) => {
                    return (
                        <div 
                            key={index}
                            className="app-custom-property-choice"
                        >
                            <input 
                                type="text"
                                placeholder="Enter another choice"
                                autoFocus={index === choices.length - 1}
                                value={choice}
                                onKeyDown={(e) => {
                                    if (index === choices.length -1 && e.key === "Enter") {
                                        setChoices([...choices, ""]);
                                    }
                                }}
                                onChange={(e) => {
                                    const newChoices = [...choices];
                                    newChoices[index] = e.target.value;
                                    setChoices(newChoices);
                                }}
                                style={flashEmpty && choice === "" ? {borderColor: "red"} : {}}
                            />
                            
                            <div 
                                className="app-custom-property-choice-default"
                                style={(defaultChoices.length > 0 && defaultChoices.includes(choice)) ? {display: "flex"} : {}}
                            >
                                {choice &&
                                    <BadgeCheck 
                                        size={16}
                                        color={defaultChoices.includes(choice) ? "green" : "black"}
                                        onClick={() => {
                                            setDefaultChoices(defaultChoices.includes(choice) ? 
                                                defaultChoices.filter((c) => c !== choice) : [...defaultChoices, choice]);
                                        }}
                                    />
                                }
                            </div>

                            <div className="app-custom-property-choice-delete">
                                <Trash 
                                    size={16}
                                    onClick={() => {
                                        setChoices(choices.filter((_, i) => i !== index));
                                    }}
                                />
                            </div>
                           
                            <div className="app-custom-property-choice-default">
                                <CircleCheck 
                                    size={16}
                                    onClick={() => {
                                        setDefaultChoices(defaultChoices.includes(choice) ? 
                                            defaultChoices.filter((c) => c !== choice) : [...defaultChoices, choice]);
                                    }}
                                    color={(choice && defaultChoices.includes(choice)) ? "green" : "black"}
                                />
                            </div>
                           
                        </div>
                    )}
                )}
            </div>
          
        </div>
    )
}